onComplete(function() {
	// Navbar: 'scrolled' class zodra je van de hero af scrollt (voor een solide achtergrond).
	var nav = document.querySelector('.nav-header');
	if (nav) {
		var threshold = 80;
		var onScroll = function() {
			nav.classList.toggle('scrolled', window.scrollY > threshold);
		};
		onScroll();
		window.addEventListener('scroll', onScroll, { passive: true });
	}






	const POPUP_IDENTIFIER = 'melding'
	const POPUP_DISMISSED_KEY = 'popup-' + POPUP_IDENTIFIER + '-dismissed'

	// sessionStorage kan een fout gooien (bv. privévenster of geblokkeerde site-data).
	// In dat geval tonen we de pop-up gewoon, zodat de melding nooit ongemerkt verdwijnt.
	const isPopupDismissed = function() {
		try {
			return sessionStorage.getItem(POPUP_DISMISSED_KEY) === '1'
		} catch (e) {
			return false
		}
	}

	if (
		!document.documentElement.hasAttribute('data-logged') ||
		document.documentElement.getAttribute('data-logged') === 'false'
	) {
		const popupElement = document.getElementById(POPUP_IDENTIFIER)
		const presetList = popupElement && popupElement.querySelector('[data-partial="preset-list"]:not([data-preset-count="0"])')
		if (presetList && !isPopupDismissed()) {
			window.modalShow.show('#' + POPUP_IDENTIFIER)

			// Alleen het kruisje onthouden: dat is een bewuste keuze van de bezoeker om de melding weg te klikken.
			popupElement.addEventListener('click', function(event) {
				if (!event.target.closest('[data-dismiss="modal"]')) return
				try {
					sessionStorage.setItem(POPUP_DISMISSED_KEY, '1')
				} catch (e) {}
			})
		}
	}
});